// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"7ab14c06","343":"5fabd9ac","517":"7557264b"}[chunkId] + ".chunk.js";
};